
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaioutstationcabs() {



    const cardData =
    {
        keyword: 'Mumbai Outstation Cabs',
        heading: 'Skyline Cabs:  Mumbai Outstation Cabs',
        headingDescription: 'Skyline Cabs offers reliable and affordable Mumbai Outstation Cabs for comfortable long-distance travel from the city to your favorite destinations. Whether you are planning a weekend getaway, a business trip, or a family vacation, our fleet of well-maintained vehicles and professional drivers ensure a safe and enjoyable journey. With flexible pickup locations across Mumbai, transparent pricing, and 24/7 customer support, Skyline Cabs is your trusted partner for outstation travel. Book your outstation cab from Mumbai today and experience smooth, stress-free intercity rides.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "Built in 1924, the Gateway of India is one of Mumbai’s most iconic landmarks. Overlooking the Arabian Sea, this grand archway was constructed to commemorate the visit of King George V and Queen Mary. It’s a popular spot for tourists and locals alike, offering ferry rides to Elephanta Caves and scenic sunset views."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus",
        "description": "A UNESCO World Heritage Site, this historic railway station is a masterpiece of Victorian Gothic architecture blended with Indian elements. Formerly known as Victoria Terminus, it is both a functioning railway station and an architectural marvel that reflects Mumbai’s colonial past."
    },
    {
        "title": "Marine Drive",
        "description": "Also known as the Queen’s Necklace, Marine Drive is a 3.6 km-long boulevard along the coast of South Mumbai. It’s a favorite hangout for evening strolls, sunsets, and panoramic views of the city skyline. At night, the streetlights resemble a string of pearls, adding to its charm."
    },
    {
        "title": "Elephanta Caves",
        "description": "Located on Elephanta Island, a short ferry ride from the Gateway of India, these UNESCO-listed rock-cut caves date back to the 5th–8th centuries. The caves are famous for their stunning sculptures and carvings dedicated to Lord Shiva, especially the majestic Trimurti sculpture."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "Dedicated to Lord Ganesha, the Siddhivinayak Temple in Prabhadevi is one of the most visited temples in Mumbai. Known for its spiritual energy and the faith it inspires, it draws thousands of devotees, including Bollywood celebrities and politicians."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and tomb located on an islet off the coast of Worli, Haji Ali Dargah is a symbol of Mumbai’s religious harmony. Connected to the mainland by a narrow causeway, it is both a pilgrimage site and an architectural gem offering serene sea views."
    },
    {
        "title": "Chor Bazaar",
        "description": "One of the oldest markets in Mumbai, Chor Bazaar is famous for antiques, vintage collectibles, furniture, and quirky treasures. Wandering through its crowded alleys offers a unique shopping experience and a glimpse into the city’s diverse culture and heritage."
    },
    {
        "title": "Juhu Beach",
        "description": "A popular beach destination in suburban Mumbai, Juhu Beach is known for its street food stalls, Bollywood celebrity homes, and leisurely atmosphere. It's the perfect spot for a seaside walk or indulging in local snacks like pav bhaji and bhel puri."
    },
    {
        "title": "Sanjay Gandhi National Park",
        "description": "Located in the northern part of Mumbai, this massive national park is a green escape from the urban hustle. Home to leopards, deer, and countless bird species, it also features the ancient Kanheri Caves and offers nature trails, boating, and safaris."
    },
    {
        "title": "Colaba Causeway",
        "description": "A bustling street market near the Gateway of India, Colaba Causeway is a shopper’s paradise filled with street stalls, boutiques, cafes, and colonial-era architecture. It’s ideal for picking up souvenirs, fashion, accessories, and enjoying Mumbai’s cosmopolitan vibe."
    }
],

"services": [
    {
      "name": "Mumbai Outstation Cabs",
      "description": "Skyline Cabs offers comfortable and reliable outstation cabs from Mumbai to various destinations. Whether you're planning a weekend trip, a family vacation, or a business visit, our fleet is ready to serve you with affordable pricing and professional service."
    },
    {
      "name": "Outstation Taxi Service in Mumbai",
      "description": "Book your outstation taxi with Skyline Cabs in Mumbai and travel stress-free. We provide well-maintained vehicles, trained chauffeurs, and 24/7 customer support to ensure your journey is smooth and enjoyable."
    },
    {
      "name": "Mumbai to Outstation Taxi",
      "description": "Need a taxi from Mumbai to a nearby city? Skyline Cabs provides one-way and round-trip outstation taxi services to popular destinations like Pune, Lonavala, Nashik, Goa, and more. Choose from a wide range of cars from sedans to SUVs."
    },
    {
      "name": "Outstation Cab Booking in Mumbai",
      "description": "Plan your next outstation trip with Skyline Cabs and enjoy seamless cab booking in Mumbai. With flexible options, instant confirmations, and fixed pricing, your long-distance travel becomes simple and convenient."
    },
    {
      "name": "Outstation Car Rental Mumbai",
      "description": "Skyline Cabs offers premium car rentals for outstation travel from Mumbai. Choose hourly, daily, or multi-day rental packages with chauffeur-driven services tailored to your itinerary and travel plans."
    },
    {
      "name": "Taxi for Outstation Trips from Mumbai",
      "description": "Travel in comfort with Skyline Cabs’ outstation taxis from Mumbai. Our experienced drivers, clean vehicles, and punctual service make your intercity travel relaxed and worry-free. Ideal for business travelers and families alike."
    },
    {
      "name": "Mumbai to Pune Outstation Cab",
      "description": "Book a Mumbai to Pune outstation cab with Skyline Cabs for a fast, safe, and affordable ride. Choose from sedans, Ertiga, or Innova Crysta with one-way or return options available. No hidden charges, full transparency."
    },
    {
      "name": "Mumbai to Goa Outstation Cab",
      "description": "Skyline Cabs offers premium outstation cabs from Mumbai to Goa. Perfect for long-distance leisure travel, our cabs are comfortable, spacious, and driven by professionals to ensure a memorable trip to the beach paradise."
    }
  ],
  "tableData": [
    ["Mumbai Outstation Cabs", "Outstation Taxi Service in Mumbai"],
    ["Mumbai to Outstation Taxi", "Outstation Cab Booking in Mumbai"],
    ["Outstation Car Rental Mumbai", "Taxi for Outstation Trips from Mumbai"],
    ["Mumbai to Pune Outstation Cab", "Mumbai to Goa Outstation Cab"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Mumbai Outstation Cab Service",
        "WhyChoosedescription": "Our Mumbai Outstation cab service ensures punctuality and reliability, providing a comfortable and hassle-free ride for your trips outside the city, whether for business or leisure."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Cabs",
        "WhyChoosedescription": "Travel in comfort with our spacious outstation cabs, offering ample legroom and luggage space, perfect for long journeys to nearby cities and destinations."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We offer budget-friendly pricing for Mumbai Outstation cabs with no hidden charges. Enjoy clear, upfront pricing for a stress-free trip."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are well-trained, experienced, and familiar with the best routes for outstation travel. They prioritize your safety and comfort throughout the journey."
    },
    {
        "WhyChooseheading": "Well-Maintained and Clean Vehicles",
        "WhyChoosedescription": "All our outstation cabs are regularly serviced, cleaned, and sanitized to ensure a safe, hygienic, and comfortable travel experience for all passengers."
    },
    {
        "WhyChooseheading": "Flexible Rental Options",
        "WhyChoosedescription": "Whether it's a one-way trip, round trip, or extended journey, we offer flexible outstation rental packages to match your specific travel needs."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Easy Booking",
        "WhyChoosedescription": "Booking your Mumbai Outstation cab is simple with 24/7 customer support available online or over the phone. We ensure a seamless booking process and provide instant confirmations."
    },
    {
        "WhyChooseheading": "Ideal for Family, Business, and Group Travel",
        "WhyChoosedescription": "Our outstation cabs are perfect for family vacations, business trips, or group getaways, offering the right balance of comfort, space, and convenience for all types of travel."
    }
]












    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book an outstation cab from Mumbai with Skyline Cabs?',
            answer:
                'Booking an outstation cab from Mumbai is easy. Use our website, mobile app, or call our customer support. Enter your destination, travel dates, and choose from a range of vehicles. Confirm the booking and you’re all set.',
        },
        {
            id: 2,
            question: 'What destinations are covered under Mumbai outstation cab services?',
            answer:
                'Skyline Cabs offers outstation services from Mumbai to popular destinations like Pune, Lonavala, Shirdi, Nashik, Mahabaleshwar, Goa, Ahmedabad, and many more. Custom routes are also available upon request.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for outstation trips from Mumbai?',
            answer:
                'We offer a variety of vehicles for outstation travel including Swift Dzire, Ertiga, Innova Crysta, Kia Carens, Fortuner, Tempo Traveller, and Force Urbania – suited for all group sizes and travel needs.',
        },
        {
            id: 4,
            question: 'Are the fares for outstation cabs from Mumbai fixed?',
            answer:
                'Yes, we provide fixed and transparent pricing for all outstation bookings. The fare includes tolls, taxes, driver allowance, and there are no hidden charges.',
        },
        {
            id: 5,
            question: 'Can I book a one-way outstation cab from Mumbai?',
            answer:
                'Yes, we offer convenient one-way cab services from Mumbai to major cities and towns. Just select “One-Way” during the booking process.',
        },
        {
            id: 6,
            question: 'Is round-trip booking available for outstation travel from Mumbai?',
            answer:
                'Yes, you can easily book a round-trip cab. Provide your return details while booking and we’ll manage the entire journey for you.',
        },
        {
            id: 7,
            question: 'Are your outstation cabs safe and well-maintained?',
            answer:
                'Absolutely. All our vehicles are regularly serviced, cleaned, and sanitized. Our drivers are experienced and trained for long-distance travel, ensuring safety and comfort.',
        },
        {
            id: 8,
            question: 'What payment options are available for Mumbai outstation cabs?',
            answer:
                'We offer flexible payment options including UPI, debit/credit cards, net banking, and cash payments. All online transactions are secure and fast.',
        },
        {
            id: 9,
            question: 'Can I modify or cancel my outstation cab booking?',
            answer:
                'Yes, Skyline Cabs allows easy modifications and cancellations through our website, app, or customer care. We offer flexible policies to accommodate changes in your plans.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for outstation travel from Mumbai?',
            answer:
                'Skyline Cabs is known for its reliable service, professional drivers, clean vehicles, and transparent pricing. Whether it’s a quick business trip or a weekend getaway, we ensure a smooth and safe journey.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "Booked an outstation cab from Mumbai to Shirdi. The vehicle was clean, driver was polite, and the journey was smooth. I highly recommend Skyline Cabs for long-distance travel!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Used Skyline Cabs for a family trip from Mumbai to Mahabaleshwar. The experience was great – on-time service and very comfortable ride. Will definitely book again!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Outstation Cabs",
  "image": "https://skylinecabs.com/assets/images/mumbai-outstation-cabs.jpg",
  "description": "Book Mumbai Outstation Cabs with Skyline Cabs for reliable and comfortable travel to Pune, Nashik, Shirdi, Lonavala, and other destinations. Choose from AC sedans, SUVs, or tempo travellers — 24/7 availability and fixed pricing.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8947"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1599",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-outstation-cabs"
  }
};



      
     
      


    return (
        <div>
<Helmet>
  <title>Mumbai Outstation Cabs | AC Sedans & SUVs at Best Fare | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai Outstation Cabs with Skyline Cabs for reliable and comfortable travel to Pune, Nashik, Shirdi, Lonavala, and other destinations. Choose from AC sedans, SUVs, or tempo travellers — 24/7 availability and fixed pricing." 
  />
  <meta 
    name="keywords" 
    content="Mumbai Outstation Cabs, Outstation Taxi from Mumbai, Mumbai to Pune Cab, Mumbai to Shirdi Taxi, SUV Cab Mumbai Outstation, AC Taxi Mumbai, Outstation Cab Booking Mumbai, One Way Cab Mumbai, Skyline Cabs Mumbai Outstation" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/79.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaioutstationcabs;